'use client';
import { jsx } from 'react/jsx-runtime';
import { cx } from '@chakra-ui/utils/cx';
import { useDialogContext, useDialogStyles } from './dialog-context.mjs';
import { DialogFocusScope } from './dialog-focus-scope.mjs';
import { DialogTransition } from './dialog-transition.mjs';
import { forwardRef } from '../system/forward-ref.mjs';

const DialogContent = forwardRef(
  function DialogContent2(props, ref) {
    const { className, children, motionProps, ...restProps } = props;
    const api = useDialogContext();
    const styles = useDialogStyles();
    return /* @__PURE__ */ jsx(DialogFocusScope, { children: /* @__PURE__ */ jsx(
      DialogTransition,
      {
        preset: api.motionPreset,
        motionProps,
        ...api.getContentProps(restProps, ref),
        className: cx("chakra-dialog__content", className),
        __css: styles.content,
        children
      }
    ) });
  }
);
DialogContent.displayName = "DialogContent";

export { DialogContent };
